<template>
  <v-btn
    v-if="isAndroid && deferredPrompt && !isInStandaloneMode"
    small
    color="#fff"
    elevation="0"
    style="width: fit-content;"
    @click="installApp"
  >
    <v-icon color="#101010">
      mdi mdi-download
    </v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'AppInstallPrompt',
  data () {
    return {
      deferredPrompt: null,
      isAndroid: false,
      isInStandaloneMode: false,
    };
  },
  mounted () {
    // Check if device is Android
    this.isAndroid = /android/i.test(navigator.userAgent);

    // Check if the app is already installed (standalone mode)
    this.isInStandaloneMode = window.matchMedia('(display-mode: standalone)').matches;

    // Listen for the install prompt
    window.addEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt);
  },
  beforeUnmount () {
    window.removeEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt);
  },
  methods: {
    handleBeforeInstallPrompt (e) {
      e.preventDefault();
      this.deferredPrompt = e;
    },
    async installApp () {
      if (this.deferredPrompt) {
        this.deferredPrompt.prompt();
        await this.deferredPrompt.userChoice;
        this.deferredPrompt = null;
      }
    },
  },
};
</script>
